/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientPlaylistModel } from '../../models/patient-playlist-model';

export interface GetPatientPlaylistContent$Params {
  playlistID?: number;
}

export function GetPatientPlaylistContent(http: HttpClient, rootUrl: string, params?: GetPatientPlaylistContent$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientPlaylistModel>> {
  const rb = new RequestBuilder(rootUrl, GetPatientPlaylistContent.PATH, 'get');
  if (params) {
    rb.query('playlistID', params.playlistID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PatientPlaylistModel>;
    })
  );
}

GetPatientPlaylistContent.PATH = '/api/Supervisor/GetPatientPlaylistContent';
